export const NAVIGATION = {
  'details': ['browse',  'productConfigurator', 'details'],
  'productConfigurator': ['details', 'productConfigurator'],
  'manageProduct': ['manageProduct', 'manage',  'user/add',  'manageUsers/action',
    'manageProduct/modifyLicense',  'manageProduct/cancel-product',  'changeProduct',  'userSummary'],
  'cart': ['cart', 'productConfigurator', 'checkout'],
  'checkout': ['cart', 'checkout'],
  'bulkUsers': ['bulkUsers', 'dashboard', 'manageUsers'],
  'manageUsers': ['manageUsers', 'manage', 'manageProduct', 'dashboard'],
  'changeProduct': ['manageProduct', 'changeProduct'],
  'modifyLicense': ['manageProduct', 'manageProduct/modifyLicense', '/manageProduct/revieworderproduct'],
  'revieworderproduct': ['manageProduct/revieworderproduct', 'manageProduct/modifyLicense'],
  'cancel-product': ['manageProduct/cancel-product', 'manageProduct/revieworderproduct']
};
